<template>
    <div class="email-card-component">
        <div class="email-card-component__header">
            <div>
                <span class="email-card-component__eyebrow">Contatos</span>
                <h6 :class="required ? 'required': ''">
                    <i class="icon-email"></i> {{ t('GENERAL.EMAIL') }}
                </h6>
                <small>{{ emails?.length ? 'E-mails cadastrados para contato.' : 'Nenhum E-mail Cadastrado' }}</small>
            </div>
            <button data-cy="user_index_add_phone" class="btn btn-primary email-card-component__add" type="button" data-target="#addNew"
                    data-toggle="modal" @click="startAdd()" v-if="!isView">
                <i class="icon-plus"></i> {{ t('ACTIONS.NEW') }}
            </button>
        </div>

        <div class="email-card-component__list" v-if="emails && emails[0]">
            <div class="email-card-component__item" v-for="(email, key) in emails" :key="email.id || key">
                <div class="email-card-component__avatar">
                    <i class="icon-email"></i>
                </div>
                <div class="email-card-component__content">
                    <strong class="email-card-component__address">{{ email.email }}</strong>
                    <small class="email-card-component__description">{{ email.description || t('GENERAL.COMMENT') }}</small>
                </div>
                <div class="email-card-component__actions" v-if="!isView">
                    <button data-cy="user_index_phone_update" class="btn btn-outline-primary btn-sm" type="button" @click="edit(email, key)">
                        <i class="icon-edit"></i>
                    </button>
                    <button data-cy="user_index_phone_delete" class="btn btn-outline-danger btn-sm" type="button" @click="deleteEmail(key, email)">
                        <i class="icon-delete"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="email-card-component__empty" v-else>
            Nenhum E-mail Cadastrado
        </div>

        <div v-if="firstModal == 'true'" class="validation text-left mt-2">
            {{ t('GENERAL.MSG.PLEASE_ADD_A_PHONE_TO_GO_AFTER') }}
        </div>

        <transition name="fade">
            <div class="modal-mask" v-if="add">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog email-card-modal" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color email-card-modal__header">
                                <div>
                                    <span class="email-card-component__eyebrow">{{ isEdit ? t('ACTIONS.UPDATE') : t('ACTIONS.NEW') }}</span>
                                    <h4 class="modal-title">{{ t('GENERAL.EMAIL') }}</h4>
                                </div>
                                <button type="button" class="closeX" id="closeX" @click="cancel()">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-open">
                                <div class="modal-body modal-row2 email-card-modal__body">
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="email" class="required">{{ t('COMPANY.EMAIL') }}: </label>
                                                <input data-cy="profile_update_modal_phone" type="tel" id="email"
                                                       name="email"
                                                       class="form-control" placeholder="E-mail"
                                                       v-model="email"
                                                       @keypress="saveWithEnter($event)">
                                                <div class="validation" id="invalidphone" v-if="msgEmail">
                                                    {{ t(msgEmail) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>{{ t("GENERAL.COMMENT") }}: </label>
                                                <textarea class="form-control"
                                                          v-model="description"
                                                          maxlength="200"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-end email-card-modal__footer">
                                <button class="btn btn-secondary mr-2" type="button" @click="cancel()">
                                    {{ t("ACTIONS.CLOSE") }}
                                </button>
                                <button data-cy="user_index_add_phone_save" class="btn btn-primary" type="button" @click="createPhone()">
                                    {{ t("ACTIONS.SAVE") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';

export default {
    name: 'email',
    mixins: [Validate],
    emits:['update','delete'],
    props: {
        emailsIndex: {
            type: [Array,Object],
            defaut: [],
        },
        isView: {
            type: Boolean,
            defaut: false,
        },
        required: {
            type: Boolean,
            defaut: false,
        },
        isPublic: {
            type: Boolean,
            defaut: false,
        }
    },

    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },

    data() {
        return {
            add: false,
            type: null,
            id: null,
            emails: [],
            types: null,
            email: null,
            isEdit: false,
            position: null,
            firstPhone: null,
            description: null,
            firstModal: localStorage.getItem('firstProfileClosed'),
        }
    },

    watch: {
        emailsIndex: function () {
            this.add = false;
            this.type = null;
            this.email = null;
            this.position = null;
            this.description = null;
            this.emails = this.emailsIndex ? this.emailsIndex : [];
            this.firstPhone = localStorage.getItem('firstProfileClosed');
        },
    },

    created() {
        this.emails = this.emailsIndex ? this.emailsIndex : [];
    },

    methods: {
        startAdd() {
            this.add = true;
            this.type = null;
            this.email = null;
            this.isEdit = false;
            this.position = null;
            this.description = null;
        },

        edit(email, key) {
            this.add = true;
            this.isEdit = true;
            this.position = key;
            this.type = email.type;
            this.id = email.id;
            this.email = email.email;
            this.description = email.description;
        },

        validateEmail() {
            let valid = true;
            if (this.email == null) {
                valid = false;
                this.msgEmail = "GENERAL.MSG.REQUIRED_FIELD";
            } else {
                valid = true;
                this.msgEmail = null;
            }
            return valid;
        },

        createPhone() {
            this.invalid = [];
            if (!this.validateEmail()) {
                return;
            }

            if (this.invalid.length == 0) {
                if (this.isEdit) {
                    this.emails.splice(this.position, 1);
                }

                this.add = false;

                if (this.id) {
                    this.emails.push(
                            {
                                id: this.id,
                                email: this.email,
                                description: this.description
                            }
                    );
                } else {
                    this.emails.push(
                            {
                                email: this.email,
                                description: this.description
                            }
                    );
                }

                this.$emit('update', this.emails);
            }
        },

        deleteEmail(key, email) {
            this.emails.splice(key, 1);
            this.$emit('delete', email);
        },

        inputValid(input, id) {
            document.getElementById(id).classList.remove("is-valid");
            document.getElementById(id).classList.remove("is-invalid");
            this.validate(input, id);
        },

        validate(input, id) {
            if (input && (input.length == 14 || input.length == 15)) {
                document.getElementById(id).classList.add("is-valid");
                return true;
            } else {
                document.getElementById(id).classList.add("is-invalid");
                return false;
            }
        },

        saveWithEnter(log) {
            if (log.key == 'Enter') {
                this.createPhone();
            }
        },

        customClass(value, key, isThead = false) {
            let col = '';
            let color = '';

            if (isThead) {
                color = '';
            } else
                color = key % 2 != 0 ? 'contact-table-row-alt' : 'table-grey';

            switch (value) {
                case 0:
                    col = !this.isView ? ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6' : ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6';
                    return color + col;
                case 1:
                    col = !this.isView ? ' col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5' : ' col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6';
                    return color + col;
                case 2:
                    col = !this.isView ? ' col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5' : ' col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6';
                    return color + col;
                case 3:
                    col = ' col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2';
                    return color + col;
            }
        },

        cancel() {
            this.add = false;
        }
    }
}
</script>

<style>
.email-card-component {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.08), rgba(14, 94, 78, 0.035) 24%, transparent 58%),
        linear-gradient(135deg, #ffffff 0%, #fbfcfd 58%, #f7f9fb 100%);
    border: 1px solid #dce3ea;
    border-radius: 14px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.88),
        0 12px 28px rgba(15, 23, 42, 0.06);
    padding: 18px;
}

.email-card-component__header {
    align-items: center;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-bottom: 14px;
}

.email-card-component__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
}

.email-card-component h6 {
    color: #173b34;
    font-weight: 700;
    margin: 2px 0;
}

.email-card-component small {
    color: #6b7c78;
}

.email-card-component__add {
    border-radius: 10px;
    white-space: nowrap;
}

.email-card-component__list {
    display: grid;
    gap: 10px;
}

.email-card-component__item {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    display: flex;
    gap: 12px;
    padding: 12px;
}

.email-card-component__avatar {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
}

.email-card-component__content {
    flex: 1;
    min-width: 0;
}

.email-card-component__address {
    color: #173b34;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.email-card-component__description {
    display: block;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.email-card-component__actions {
    display: flex;
    gap: 8px;
}

.email-card-component__empty {
    background: rgba(14, 94, 78, 0.06);
    border: 1px dashed #b9d8d0;
    border-radius: 12px;
    color: #52716a;
    font-size: 13px;
    padding: 12px;
    text-align: center;
}

.email-card-modal {
    margin-top: 0;
}

.email-card-modal .modal-content {
    border: 0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 24px 70px rgba(15, 23, 42, .24);
}

.email-card-modal__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.email-card-modal__body {
    max-height: calc(100vh - 200px);
    padding: 20px;
}

.email-card-modal__body textarea.form-control {
    min-height: 130px;
}

.email-card-modal__footer {
    border-top: 1px solid #e3eeeb;
    padding: 14px 20px;
}

html.dark-theme .email-card-component,
html.dark-theme .email-card-modal .modal-content {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.20), rgba(20, 184, 166, 0.10) 24%, transparent 58%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.04),
        inset 0 0 0 1px rgba(148, 163, 184, 0.08),
        -14px -12px 38px rgba(20, 184, 166, 0.11),
        0 18px 42px rgba(2, 6, 23, 0.36) !important;
    color: var(--dark-text-soft) !important;
}

html.dark-theme .email-card-component h6,
html.dark-theme .email-card-component__address,
html.dark-theme .email-card-modal .modal-title {
    color: var(--dark-text) !important;
}

html.dark-theme .email-card-component__eyebrow {
    color: var(--dark-primary) !important;
}

html.dark-theme .email-card-component small,
html.dark-theme .email-card-component__description {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .email-card-component__item {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

html.dark-theme .email-card-component__empty {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border-strong) !important;
    color: var(--dark-text-soft) !important;
}

html.dark-theme .email-card-component__avatar {
    background: var(--dark-surface-3) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .email-card-modal__footer {
    border-top-color: var(--dark-border) !important;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */
{
    opacity: 0;
}

@media (max-width: 767px) {
    .email-card-component {
        padding: 16px;
    }

    .email-card-component__header,
    .email-card-component__item {
        align-items: flex-start;
        flex-direction: column;
    }

    .email-card-component__add,
    .email-card-component__actions,
    .email-card-component__actions .btn {
        width: 100%;
    }

    .email-card-component__avatar {
        display: none;
    }

    .email-card-component__content {
        width: 100%;
    }

    .email-card-component__description {
        white-space: normal;
    }

    .email-card-modal {
        margin: 0.5rem;
    }
}
</style>
